import { noop, isString } from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Input, mergeClasses } from '@fluentui/react-components';
import { getDomain } from '@bingads-webui/url-util';

import { validatePath } from './validation';
import { useStyles } from './styles';

export function UrlPathFluent({
  value,
  url,
  i18n,
  onChange,
}) {
  const [Path1, Path2] = value;
  const urlDomain = useMemo(() => getDomain(url), [url]);
  const onPathChange = useCallback((path, { value: newValue }) => {
    const errors = validatePath([path === 'Path1' ? newValue : Path1, path === 'Path2' ? newValue : Path2], i18n);
    onChange(errors, { [path]: newValue });
  }, [Path1, Path2, i18n, onChange]);

  const onPath1Change = useCallback((event, newValue) => {
    onPathChange('Path1', newValue);
  }, [onPathChange]);

  const onPath2Change = useCallback((event, newValue) => {
    onPathChange('Path2', newValue);
  }, [onPathChange]);

  const styles = useStyles();

  return (
    <div className={mergeClasses('url-path', styles.urlPath)}>
      <div className="display-url-text">
        {isString(urlDomain) && urlDomain.length > 0 ?
          urlDomain :
          'www.example.com'
        }
      </div>
      <div className="url-separator">/</div>
      <Input
        className="path1"
        value={Path1}
        onChange={onPath1Change}
      />
      <div className="url-separator">/</div>
      <Input
        className="path2"
        value={Path2}
        onChange={onPath2Change}
      />
    </div>
  );
}

UrlPathFluent.propTypes = {
  config: PropTypes.shape({
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  url: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};

UrlPathFluent.defaultProps = {
  onChange: noop,
};
